export const coreFeaturesContainerSx = {
  flex: '1 0 50%',
};
